module.exports = __webpack_public_path__ + "assets/img/4de761dd2cce3441bc83e5cfa0770913.png";